module.exports = __webpack_public_path__ + "img/func7.af92b09c.png";